import React, { useState } from 'react';

const PointSystemGuide: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="card border-0 shadow-sm mt-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="card-body text-white">
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
          <div className="d-flex align-items-center flex-grow-1 me-2">
            <div className="bg-white bg-opacity-20 rounded-circle p-2 p-md-3 me-2 me-md-3">
              <i className="fas fa-coins text-dark" style={{ fontSize: '1.2rem' }}></i>
            </div>
            <div className="flex-grow-1">
              <h5 className="card-title mb-1 text-white fs-6 fs-md-5">🎯 Maximize Your Points!</h5>
              <p className="mb-0 text-white-50 small d-none d-sm-block">Learn how to earn the most points from quizzes</p>
              <p className="mb-0 text-white-50 small d-sm-none">Earn max points!</p>
            </div>
          </div>
          <button
            className="btn btn-outline-light btn-sm flex-shrink-0"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`}></i>
          </button>
        </div>

        {/* Quick Points Summary */}
        <div className="row g-2 g-md-3 mb-3">
          <div className="col-4">
            <div className="text-center">
              <div className="h5 h4-md mb-1 text-white fw-bold" 
                   style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                ⭐ 360
              </div>
              <small className="text-white d-none d-sm-inline" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                Score 90%+
              </small>
              <small className="text-white d-sm-none" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                90%+
              </small>
            </div>
          </div>
          <div className="col-4">
            <div className="text-center">
              <div className="h5 h4-md mb-1 text-white fw-bold" 
                   style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                💎 +120
              </div>
              <small className="text-white d-none d-sm-inline" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                Hard Level
              </small>
              <small className="text-white d-sm-none" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                Hard
              </small>
            </div>
          </div>
          <div className="col-4">
            <div className="text-center">
              <div className="h5 h4-md mb-1 text-white fw-bold" 
                   style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                🎯 +60
              </div>
              <small className="text-white d-none d-sm-inline" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                No Skips
              </small>
              <small className="text-white d-sm-none" 
                     style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
                No Skip
              </small>
            </div>
          </div>
        </div>

        {/* View More Button - Only shown when collapsed */}
        {!isExpanded && (
          <div className="text-center">
            <button
              className="btn btn-outline-light btn-sm px-4"
              onClick={() => setIsExpanded(true)}
            >
              <i className="fas fa-eye me-2"></i>
              View More Details
            </button>
          </div>
        )}

        {/* Expandable Detailed Information */}
        {isExpanded && (
          <div className="mt-4 pt-3 border-top border-white border-opacity-25">
            <div className="row g-4">
              <div className="col-md-6">
                <h6 className="text-white mb-3">
                  <i className="fas fa-trophy me-2"></i>
                  Score-Based Points
                </h6>
                <div className="space-y-2">
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">🔥 High Score (90%+)</span>
                    <span className="badge bg-warning text-dark fw-bold">360 points</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">📈 Medium Score (50-90%)</span>
                    <span className="badge bg-info text-dark fw-bold">240 points</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">📚 Low Score (&lt;50%)</span>
                    <span className="badge bg-secondary fw-bold">120 points</span>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <h6 className="text-white mb-3">
                  <i className="fas fa-gift me-2"></i>
                  Bonus Points
                </h6>
                <div className="space-y-2">
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">💎 Hard Level Quiz</span>
                    <span className="badge bg-info fw-bold">+120 pts</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">🎯 No Skipped Questions</span>
                    <span className="badge bg-success fw-bold">+60 pts</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-white bg-opacity-10 rounded">
                    <span className="text-dark">⚡ Perfect + Speed (Soon)</span>
                    <span className="badge bg-primary fw-bold">+360 pts</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-4 mt-2">
              <div className="col-md-6">
                <h6 className="text-white mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  Requirements
                </h6>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="fas fa-check-circle text-success me-2"></i>
                    <span className="text-white">Minimum 20 questions per quiz</span>
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-calendar-week text-info me-2"></i>
                    <span className="text-white">Weekly limit: 1,200 points (resets Monday)</span>
                  </li>
                </ul>
              </div>

              <div className="col-md-6">
                <h6 className="text-white mb-3">
                  <i className="fas fa-lightbulb me-2"></i>
                  Pro Tips
                </h6>
                <ul className="list-unstyled mb-0">
                  <li className="mb-2">
                    <i className="fas fa-star text-warning me-2"></i>
                    <span className="text-white">Aim for 90%+ to get maximum base points</span>
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-diamond text-info me-2"></i>
                    <span className="text-white">Choose hard level for extra 120 bonus points</span>
                  </li>
                  <li className="mb-2">
                    <i className="fas fa-target text-success me-2"></i>
                    <span className="text-white">Never skip questions for +60 bonus</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="alert alert-light mt-3 mb-0">
              <div className="row align-items-center">
                <div className="col-auto">
                  <i className="fas fa-calculator text-primary" style={{ fontSize: '2rem' }}></i>
                </div>
                <div className="col">
                  <h6 className="text-dark mb-1">🏆 Maximum Possible Points</h6>
                  <p className="text-dark mb-0">
                    <strong>540 points</strong> = 360 (high score) + 120 (hard level) + 60 (no skips)
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PointSystemGuide;